import React from 'react';
import { Box, LinearProgress, Typography, Chip } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';

const QuizProgress = ({ currentQuestion, totalQuestions, answeredQuestions }) => {
  const progress = ((currentQuestion) / totalQuestions) * 100;
  const answeredCount = Object.keys(answeredQuestions).length;

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Progression
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Chip 
            icon={<CheckCircle />}
            label={`${answeredCount}/${totalQuestions} répondu${answeredCount > 1 ? 'es' : ''}`}
            size="small"
            color={answeredCount === totalQuestions ? 'success' : 'default'}
            variant="outlined"
          />
        </Box>
      </Box>
      <LinearProgress 
        variant="determinate" 
        value={progress} 
        sx={{ height: 10, borderRadius: 1 }}
      />
      <Box sx={{ display: 'flex', gap: 0.5, mt: 2, flexWrap: 'wrap' }}>
        {Array.from({ length: totalQuestions }, (_, i) => i + 1).map((num) => (
          <Chip
            key={num}
            label={num}
            size="small"
            color={num === currentQuestion + 1 ? 'primary' : 'default'}
            variant={answeredQuestions[num - 1] !== undefined ? 'filled' : 'outlined'}
            icon={answeredQuestions[num - 1] !== undefined ? <CheckCircle /> : <RadioButtonUnchecked />}
            sx={{ minWidth: 40 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default QuizProgress;

